export default __webpack_public_path__ + "static/media/promises.8046a314.svg";